"use client";

import LandingFooter from "../../components/landing/LandingFooter";
import styles from "./download.module.css";

const AppleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

export default function DownloadClient({ latestVersion }) {
  const handleDownload = (arch) => {
    const archSuffix = arch === "intel" ? "x64" : "arm64";
    const downloadUrl = `https://appdownload.flare.link/Flare-${latestVersion}-${archSuffix}.dmg`;
    window.location.href = downloadUrl;
  };

  return (
    <div className={styles.container}>
      <main className={styles.main}>
        {/* Hero Section */}
        <section className={styles.hero}>
          <div className={styles.heroContent}>
            <h1 className={styles.title}>Download Flare</h1>

            <p className={styles.version}>Version {latestVersion}</p>

            <div className={styles.downloadButtons}>
              <button
                type="button"
                onClick={() => handleDownload("arm64")}
                className={styles.buttonPrimary}
              >
                <AppleIcon />
                Download for Apple Silicon
              </button>

              <button
                type="button"
                onClick={() => handleDownload("intel")}
                className={styles.buttonSecondary}
              >
                <AppleIcon />
                Download for Intel
              </button>
            </div>

            <p className={styles.note}>~120 MB · macOS 14.0 or later</p>
          </div>
        </section>

        {/* Requirements Section */}
        <section className={styles.requirements}>
          <div className={styles.requirementsContent}>
            <h2 className={styles.sectionTitle}>System Requirements</h2>

            <div className={styles.tableWrapper}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th>Component</th>
                    <th>Minimum</th>
                    <th>Recommended</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>macOS</td>
                    <td>14.0 (Sonoma)</td>
                    <td>15.0+ (Sequoia)</td>
                  </tr>
                  <tr>
                    <td>Processor</td>
                    <td>Apple Silicon or Intel</td>
                    <td>Apple Silicon</td>
                  </tr>
                  <tr>
                    <td>RAM</td>
                    <td>4 GB</td>
                    <td>8 GB+</td>
                  </tr>
                  <tr>
                    <td>Storage</td>
                    <td>1 GB available</td>
                    <td>2 GB+ available</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Installation Section */}
        <section className={styles.installation}>
          <div className={styles.installationContent}>
            <h2 className={styles.sectionTitle}>Installation</h2>

            <ol className={styles.steps}>
              <li className={styles.step}>
                <span className={styles.stepNumber}>1</span>
                <div className={styles.stepContent}>
                  <h3>Download the DMG file</h3>
                  <p>Click the download button above to get the installer.</p>
                </div>
              </li>
              <li className={styles.step}>
                <span className={styles.stepNumber}>2</span>
                <div className={styles.stepContent}>
                  <h3>Open the downloaded file</h3>
                  <p>Double-click the .dmg file in your Downloads folder.</p>
                </div>
              </li>
              <li className={styles.step}>
                <span className={styles.stepNumber}>3</span>
                <div className={styles.stepContent}>
                  <h3>Drag Flare to Applications</h3>
                  <p>Drag the Flare icon to your Applications folder.</p>
                </div>
              </li>
              <li className={styles.step}>
                <span className={styles.stepNumber}>4</span>
                <div className={styles.stepContent}>
                  <h3>Launch and sign in</h3>
                  <p>Open Flare from Applications and sign in to your account.</p>
                </div>
              </li>
              <li className={styles.step}>
                <span className={styles.stepNumber}>5</span>
                <div className={styles.stepContent}>
                  <h3>Grant permissions</h3>
                  <p>Allow screen recording and microphone access when prompted.</p>
                </div>
              </li>
            </ol>
          </div>
        </section>
      </main>

      <LandingFooter />
    </div>
  );
}
